import { Country } from '~/Api/Country';

import ActionTypes from './ActionTypes';

export interface State {
	request: Promise<any> | null;
	countries: Country[];
}

type Action =
	| { type: ActionTypes.request; request: Promise<any> | null }
	| {
			type: ActionTypes.receive;
			request: Promise<any> | null;
			countries: Country[] | null;
	  };

function createState(): State {
	return {
		request: null,
		countries: [],
	};
}

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		case ActionTypes.request:
			return { ...state, request: action.request };

		case ActionTypes.receive:
			if (state.request !== action.request) {
				return state;
			}
			if (!action.countries) {
				return { ...state, request: null };
			}
			return { ...state, countries: action.countries };

		default:
			return state;
	}
}
